<template>
  <BreadCrumb PageTitle="Close Button" />
  <CloseButton />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import CloseButton from "../../template-components/UIElements/CloseButton/CloseButton.vue";

export default defineComponent({
  name: "CloseButtonPage",
  components: {
    BreadCrumb,
    CloseButton,
  },
});
</script>